var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.648 14.711L11.997 18l3.35-3.289a2.13 2.13 0 000-3.069 2.225 2.225 0 00-3.126 0l-.224.219-.224-.219a2.224 2.224 0 00-3.125 0 2.128 2.128 0 000 3.069z","key":0}),React.createElement("path",{"d":"M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z","key":1})]);
}

Calendar.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Calendar;

Calendar.default = Calendar;
